export default {
    CONNECT: {
        TOKEN: "connect/token",
        USERINFO: "connect/userinfo",
    },
    AUTH: {
        REQUEST_LOGIN_CODE: "api/auth/requestLoginCode",
        LOGIN_OPTIONS: "api/auth/loginOptions",
    },
    PHONE_VERIFICATION: {
        ROOT: "api/phoneVerification",
        VERIFIED: "api/phoneVerification/verified",
    },
};
